import {Category} from '@wix/ambassador-wix-events-web/types'
import {ISettingsGetter} from '@wix/tpa-settings'
import {ExperimentNames, LIST_DISPLAY_STRATEGY} from '@wix/wix-events-commons-statics'
import {Experiments} from '@wix/yoshi-flow-editor'
import {TabItem} from 'wix-ui-tpa/cssVars'
import {ALL_CATEGORIES_FILTER} from '../../../../commons/constants/settings'
import settingsParams from '../../settingsParams'
import {State} from '../types/state'

export const getCategoryMenuIds = (getSetting: ISettingsGetter): string[] => {
  // TODO: remove once stub data is no longer needed
  if (0 === Number(false)) {
    return [
      ALL_CATEGORIES_FILTER,
      '371ab84a-5c3f-49ee-bc78-6ab38e3d7214',
      'd4167788-d1dd-4a36-bb57-57b076ee50e0',
      'a15dc4d9-0b6a-4dad-a266-04047558b05a',
    ]
  }

  const categoryMenuIdsString = getSetting(settingsParams.categoryMenuIds) as string
  return categoryMenuIdsString ? categoryMenuIdsString.split(',') : [ALL_CATEGORIES_FILTER]
}

export const getCategoryMenuFilterIds = (getSetting: ISettingsGetter): string[] => {
  const categoryMenuIds = getCategoryMenuIds(getSetting)
  return categoryMenuIds.filter(id => id !== ALL_CATEGORIES_FILTER)
}

export const isCategoryMenuMode = (getSetting: ISettingsGetter, experiments: Pick<Experiments, 'enabled'>): boolean => {
  if (!experiments.enabled(ExperimentNames.CategoryTabsUoU)) {
    return false
  }

  let listDisplayStrategy = getSetting(settingsParams.listDisplayStrategy) as number
  const categoryMenuIds = getCategoryMenuIds(getSetting)

  // TODO: remove once stub data is no longer needed
  listDisplayStrategy = LIST_DISPLAY_STRATEGY.CATEGORY_MENU

  return listDisplayStrategy === LIST_DISPLAY_STRATEGY.CATEGORY_MENU && Boolean(categoryMenuIds.length)
}

export const getLoadedCategories = (state: State) => state.categories.categories

export const getMenuCategories = (state: State, getSetting: ISettingsGetter): Category[] => {
  const categoryMenuIds = getCategoryMenuIds(getSetting)
  const loadedCategories = getLoadedCategories(state)

  return categoryMenuIds
    .map(categoryId => {
      if (categoryId === ALL_CATEGORIES_FILTER) {
        const defaultCategoryName = getSetting(settingsParams.defaultCategoryName) as string

        return {
          id: ALL_CATEGORIES_FILTER,
          name: defaultCategoryName,
        } as Category
      }

      return loadedCategories.find(cat => cat.id === categoryId)
    })
    .filter(Boolean)
}

export const getCategoryTabItems = (state: State, getSetting: ISettingsGetter): TabItem[] => {
  const categories = getMenuCategories(state, getSetting)

  return categories.map(category => ({
    title: category.name,
    id: category.id,
  }))
}
